// React
import { FunctionComponent } from "react";
// Library
import { Title } from "@fyrstain/fhir-front-library";
// Components
import ApplicationPage from "../../components/ValeursPage/ValeursPage";
import { toPublicUrl } from "../../services/PublicUrl";
// Styles
import styles from "./Home.module.css";

const Home: FunctionComponent = () => {
    return (
        <ApplicationPage loading={false} needsLogin={false}>
            <>
                <div className={styles.mainHomeContainer}>
                    <img
                        className={styles.homeimageIcon}
                        alt="Home_image"
                        src={toPublicUrl("/assets/home.jpg")}
                    />
                    <div className={styles.homeTitle}>
                        <Title level={1} prefix={'UpCare - Nancy'} />
                    </div>
                </div>
            </>
        </ApplicationPage>
    );
};

export default Home;
